import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import GithubRepoCard from "../../components/githubRepoCard/GithubRepoCard";
import Button from "../../components/button/Button";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import { projectsHeader } from "../../portfolio.js";
import "./Projects.css";
import ProjectsImg from "./ProjectsImg";

const repo1 = [
  {
    id: 1,
    name: "Mealshare Website",
    description:
      "A website to share a meal by one and reserve the meal by others",
    createdAt: "Sep 2020",
    languages: ["HTML/CSS", "JavaScript", "nodejs"],
    url: "https://mealshare-anil.herokuapp.com/",
  },
  {
    id: 2,
    name: "Web Dev Rooms",
    description: "It is a study group management system for the HackYourFuture",
    createdAt: "Jan 2021",
    languages: ["React", "node", "MySql"],
    url: "https://sgms-hyf.herokuapp.com/login",
  },
  {
    id: 3,
    name: "Github User search",
    description: "To search for a user in github",
    createdAt: "Oct 2020",
    languages: ["React"],
    url: "https://github-usrer-search-anil.netlify.app/",
  },
];

class Projects extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="projects-main">
        <Header theme={theme} />
        <div className="basic-projects">
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                {/* <img
											src={require(`../../assests/images/${projectsHeader["avatar_image_path"]}`)}
											alt=""
										/> */}
                <ProjectsImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1
                  className="projects-heading-text"
                  style={{ color: theme.text }}
                >
                  {projectsHeader.title}
                </h1>
                <p
                  className="projects-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {projectsHeader["description"]}
                </p>
              </div>
            </div>
          </Fade>
        </div>
        <div className="repo-cards-div-main">
          {repo1.map((repo) => {
            return <GithubRepoCard repo={repo} theme={theme} />;
          })}
        </div>
        <Button
          text={"More Projects"}
          className="project-button"
          href="https://github.com/anilmula"
          newTab={true}
          theme={theme}
        />
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Projects;
